module.exports = __webpack_public_path__ + "static/img/waiting_receipt.d989ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/waiting_receipt.png
// module id = I9bI
// module chunks = 0